<template>
	<div>
		<span class="font-grandstander fs-1-4">
			CLASSE {{classData.class_data.classe != 0 ? classData.class_data.classe : ''}}{{classData.class_data.sezione}}
		</span><br>

		<button class="btn btn-yellow rounded-pill px-3 py-0" v-if="!classData.works_data">
			<span class="va-sub" @click.prevent="onClick(classData.class_data)">CARICA CONTRIBUTI</span>
			<i class="far fa-trash-alt va-sub ml-3 fs-1-3" @click.prevent="onClickDelete(classData.class_data)"></i>
		</button>

		<button class="btn btn-yellow rounded-pill px-3 py-0" v-else-if="classData.works_data && classData.works_data.appr_text == 0">
			<span class="va-sub" @click.prevent="onClick(classData.class_data)">CARICATI</span>
			<i class="far fa-eye va-sub ml-3 fs-1-3" @click.prevent="onClick(classData.class_data)"></i>
			<i class="far fa-trash-alt va-sub ml-3 fs-1-3" @click.prevent="onClickDelete(classData.class_data)"></i>
		</button>

		<button class="btn btn-yellow rounded-pill px-3 py-0" v-else>
			<span class="va-sub" @click.prevent="onClick(classData.class_data)">APPROVATI</span>
		</button>
	</div>
</template>

<script>
export default {
	name: 'BtnClasses',
	props: ['classData'],

	methods: {
		onClick(classItem) {
			this.$emit('btn-cliccked', classItem)
		},
		onClickDelete(classItem) {
			this.$emit('delete-class', classItem)
		}
	},

	mounted() {
		console.log()
		console.log(this.classData)
	}
}
</script>
